export default __webpack_public_path__ + "static/media/Umesh Kumar.84c82e09.jpeg";